import styled from "styled-components";

import docImg from "../../../../assets/Mayo/Doctor2.png";
import { useNavigate, useParams } from "react-router-dom";

export default function MayoInquery({style}) {
  const navigate = useNavigate();
  const { userId } = useParams();

  return(
    <Container style={style}>
      <Image
        src={docImg}
        width={168}
        height={150}
      />

      <Text>
        Still have questions?
      </Text>

      <Button
        onClick={() => navigate(`/patient/mayo/faq`)}
      >
        FAQ
      </Button>

      {/* TODO - Scroll up to the top */}
      <Button
        onClick={()=>window.scrollTo(0, 0)}
      >
        Back to Video
        {/* TODO - add up icon */}
      </Button>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
`

const Text = styled.p`
  margin: 0;
  margin-top: 14px;
  font-size: 22px;
  font-weight: 600;
`

const Button = styled.button`
  width: 250px;
  min-width: 50px;
  height: 50px;
  
  border-radius: 25px;
  border: 0;
  
  background-color: #7A9DFD;
  color: #FFFFFF;

  font-size: 19px;
  font-weight: 500;
  font-family: Abraham;
`

const Image = styled.img``